// extracted by mini-css-extract-plugin
module.exports = {"documents":"style_documents__JM5M6","background":"style_background__3GPmo","documents__wrap":"style_documents__wrap__1uyBz","backgroundBottom":"style_backgroundBottom__3tX5X"};